.cmd {
  position: relative;
  flex: 1;
  max-width: 560px;
}
.field {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 14px;
  background: var(--color-grey-lightest);
  border: 1px solid transparent;
  border-radius: 60px;
  cursor: text;
  transition:
    border-color 0.15s,
    background 0.15s;
}
.field:hover {
  border-color: var(--color-grey-lighter);
}
.fieldFocus {
  background: var(--color-white);
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-lightest);
}
.input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: var(--font-size-m);
  color: var(--color-text);
}
.input::placeholder {
  color: var(--color-grey-light);
}
.kbd {
  font-size: var(--font-size-xs);
  color: var(--color-grey-light);
  background: var(--color-white);
  border: 1px solid var(--color-grey-lighter);
  border-radius: 5px;
  padding: 2px 6px;
  font-family: ui-monospace, Menlo, monospace;
}
.pop {
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  background: var(--color-white);
  border: 1px solid var(--color-grey-lighter);
  border-radius: 16px;
  box-shadow: var(--dropdown-box-shadow);
  z-index: 50;
  overflow: hidden auto;
  max-height: 440px;
}
.sec {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--color-grey-light);
  padding: var(--spacing-3) var(--spacing-4) 6px;
}
.res {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: 9px 14px;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: inherit;
}
.res:hover,
.resCur {
  background: var(--color-primary-lightest);
}
.resMain {
  flex: 1;
  min-width: 0;
}
.resTitle {
  font-size: var(--font-size-m);
  color: var(--color-text);
}
.resTitle mark {
  background: var(--color-warning-lighter);
  color: inherit;
  border-radius: 2px;
  padding: 0 1px;
}
.resSub {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resKind {
  font-size: var(--font-size-xxs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-grey-light);
  background: var(--color-grey-lightest);
  padding: 3px var(--spacing-2);
  border-radius: 999px;
  flex-shrink: 0;
}
.empty {
  padding: 28px var(--spacing-4);
  text-align: center;
  color: var(--color-grey);
  font-size: var(--font-size-m);
}
